import * as React from "react"

//import CounterPage from "./components/CounterPage";
//import FetchDataPage from "./components/Forecast";
//import HomePage from "./components/HomePage";
//import WorkshopPage from "./components/WorkshopPage";
import PasswordPage from "./components/PasswordPage";
//import Login from "./components/Login";

//import CompanyPage from "./components/CompanyPage";
import UsersPage from "./components/UsersPage";
import { Workshops } from "./components/tabs/Workshops";
import { Dashboard } from "./components/tabs/Dashboard";
import { TestingTab } from "./components/tabs/TestingTab";
import { Results } from "./components/tabs/Results";
import { Administration } from "./components/tabs/Administration";
import { ArchitectureAdmin } from "./components/tabs/ArchitectureAdmin";
import { DBFunctionPage } from "./components/tabs/DB_Functions";
import { DBViewDevDebug } from "./components/tabs/Administration/DBViewDevDebug";
import { AllUsersAdmin } from "./components/tabs/UserAdministration";
import { LogFileAdminPage } from "./components/tabs/Administration/LogFileAdmin";
import { WSAdminstration } from "./components/tabs/WSAdministration";
import { WSUsers } from "./components/tabs/WSUsers";
import { WSUserAdministration } from "./components/tabs/WSUserAdministration";
import SettingsMenu from "./components/SettingsMenu";
import { WSMonitor } from "./components/tabs/WSMonitor";
import { ProfileModal } from "./components/modals/ProfileModal";
import { TransferRegistrationModal } from "./components/modals/TransferRegistrationModal";
import { WorkshopSettingsModal } from "./components/modals/WorkshopSettingsModal";
import { WorkshopStatisticsModal } from "./components/modals/WorkshopStatisticsModal";
import { EmulateUserModal } from "./components/modals/EmulateUserModal";
import { RouteObject } from "react-router";
import { WSTestingStart } from "./components/tabs/WSTestingStart";
import { WSTestingRecords } from "./components/tabs/WSTestingRecord/WSTestingRecordPage";
import { ListOfRegisteredUsersAndProducts } from "./components/tabs/Workshops/UserProducts";
import { ListOfRegisteredUserProducts } from "./components/tabs/Workshops/WorkshopUserProducts";
import { ImportWorkshopProductModal } from "./components/modals/ImportWorkshopProductModal";
//import { ImportProductModal } from "./components/modals/ImportProductModal";

//import { EditArrivalInformationModal } from "./components/modals/EditArrivalInformationModal";
import { ArrivalInformation } from "./components/tabs/Workshops/ArrivalInformation";
import { WSTesting } from "./components/tabs/WSTesting";
import { WSTestingConfig } from "./components/tabs/WSConfig/WSTestingConfig";

export interface PageRoute {
   name: string
   path: string
   element: any
   hidden?: boolean
   modal?: boolean
   administrator?: boolean
}

type NamedRouteObject = RouteObject & {name: string};

const AppRoutes : PageRoute[] = [
   {
      name: "Dashboard",
      path: "/",
      hidden: true,
      element: <Dashboard />
   },
   {
      name: "Dashboard",
      path: "/Dashboard",
      element: <Dashboard />
   },
   {
      name: "Workshops",
      path: "/Workshops",
      element: <Workshops />
   },
    {
        name: "Testing",
        path: "/TestingTab",
        element: <TestingTab />
    },
   {
      name: "Results",
      path: "/Results",
      element: <Results />
   },
   {
      name: "Administration",
      path: "/Administration",
      element: <Administration />,
      administrator: true,
    },
    {
        name: "ArchitectureAdmin",
        path: "/ArchitectureAdmin",
        hidden: true,
        element: <ArchitectureAdmin />,
        administrator: true,
    },
    {
        name: "DBFunctionPage",
        path: "/DBFunctionPage",
        hidden: true,
        element: <DBFunctionPage />,
        administrator: true,
    },
    {
        name: "DBViewDevDebug",
        path: "/DBViewDevDebug",
        hidden: true,
        element: <DBViewDevDebug />,
        administrator: true,
    },
    {
        name: "AllUsersAdmin",
        path: "/AllUsersAdmin",
        hidden: true,
        element: <AllUsersAdmin />,
        administrator: true,
    },
    {
        name: "LogFileAdminPage",
        path: "/LogFileAdminPage",
        hidden: true,
        element: <LogFileAdminPage />,
        administrator: true,
    },
   {
      name: "wsadministration",
      path: "/WSAdministration",
      hidden: true,
      element: <WSAdminstration  />
   },
   {
      name: "wsusers",
      path: "/WSUsers/:wsId",
      hidden: true,
      element: <WSUsers />
    },
    {
        name: "wsuseradministration",
        path: "/WSUserAdministration/:wsId",
        hidden: true,
        element: <WSUserAdministration />
    },
    {
        name: "wstesting",
        path: "/WSTesting/:id",
        hidden: true,
        element: <WSTesting />
    },
    {
        name: "wstestingconfig",
        path: "/WSTestingConfig/:id",
        hidden: true,
        element: <WSTestingConfig />
    },
   {
      name: "wsmonitor",
      path: "/WSMonitor",
      hidden: true,
      element: <WSMonitor />
   },
   {
      name: "profileModal",
      path: "/ProfileModal",
      hidden: true,
      element: <ProfileModal />,
      modal: true
   },
   {
      name: "transferRegistrationModal",
      path: "/TransferRegistrationModal",
      hidden: true,
      element: <TransferRegistrationModal />,
      modal: true
   },
   {
      name: "workshopSettingsModal",
      path: "/WorkshopSettingsModal/:id",
      hidden: true,
      element: <WorkshopSettingsModal />,
      modal: true
    },
    {
        name: "workshopStatisticsModal",
        path: "/WorkshopStatisticsModal/:id",
        hidden: true,
        element: <WorkshopStatisticsModal />,
        modal: true
    },
   /*{
      name: 'removeWorkshopProduct',
      path: '/RemoveWorkshopProduct',
      hidden: true,
      element: <RemoveWorkshopProduct />,
      modal: true,
   },*/
   {
      name: "importPreviousProductInstances",
       path: "/ImportPreviousWPInstance/:workshopId/:currentWorkshopProductId/:givenProductID",
      hidden: true,
      element: <ImportWorkshopProductModal />,
      modal: true
    },
   {
      name: "arrivalInformation",
      path: "/ArrivalInformation/:wsId",
      hidden: true,
      element: <ArrivalInformation />,
   },
   {
      name: "emulateUserModal",
      path: "/EmulateUserModal",
      hidden: true,
      element: <EmulateUserModal />,
      modal: true,
   },
    {
        name: "wstestingstart",
        path: "/WSTestingStart/:id",
        hidden: true,
        element: <WSTestingStart />
    },
    {
        name: "wstestingrecords",
        path: "/WSTestingRecords/:id",
        hidden: true,
        element: <WSTestingRecords />
    },
    {
        name: "WSResults",
        path: "/WSTestingStart/:id/:disabled",
        hidden: true,
        element: <WSTestingStart />
    },
   {
      name: "addUsersAndProducts",
      path: "/ViewUsersProducts/:id",
      hidden: true,
      element: <ListOfRegisteredUsersAndProducts />
    },
    {
        name: "viewUserProducts",
        path: "/ViewUserProducts/:id",
        hidden: true,
        element: <ListOfRegisteredUserProducts />
    },
/*    {
      name: "main.profile",
      path: "/Profile",
      element: <ProfileModal/>
   }, */
 /*   {
      name: "main.home",
      path: "/",
      element: <HomePage />
   },
   {
      name: "main.counter",
      path: "/counter",
      element: <CounterPage />
   },
   {
      name: "main.forecast",
      path: "/fetch-data",
      element: <FetchDataPage />
   }, 
   {
      name: "main.login",
      path: "/login",
      hidden: true,
      element: <Login />
   },*/
   {
      name: "main.password",
      path: "/password",
      hidden: true,
      element: <PasswordPage />
   },
   {
      name: "main.user",
      path: "/userProfile",
      hidden: true,
      element: <UsersPage />
   },
   {
      name: "main.settings",
      path: "/settings",
      hidden: true,
      element: <SettingsMenu />
   }
/* {
      name: "main.company",
      path: "/companies",
      hidden: false,
      element: <CompanyPage />
   },

   {
      name: "main.users",
      path: "/users",
      hidden: false,
      element: <UsersPage />
   } */


];

export default AppRoutes;
